import { RouteObject } from 'react-router-dom';

//components
import App from 'App';
import AuthGuard from 'core/guards/authGuard';
import { CheckPermission } from 'utils/checkPermission';
import { CheckSuspended } from 'utils/checkSuspended';

import MainDashboardLayout from 'core/layouts/main/mainLayout';
import LoginPage from 'modules/main/auth/login/pages/login';
import NotFoundPage from 'components/404/notFound';
import ResetPasswordPage from 'modules/main/auth/reset-password/pages/reset-password';
import RegisterPage from 'modules/main/auth/register/pages/register';
import ContactRegisterForm from 'modules/main/auth/register/components/contactForm';
import RegisterOtp from 'modules/main/auth/register/components/otp';
import CompanyRegisterForm from 'modules/main/auth/register/components/companyForm';
import RegistryPlans from 'modules/main/auth/register/components/plans';
import AgreementRegister from 'modules/main/auth/register/components/agreement';
import CompanyDocumentsPage from 'modules/main/companyDocuments/pages/companyDocuments';
import DashboardPage from 'modules/main/dashboard/pages/dashboard';
import UserProfilePage from 'modules/main/userProfile/pages/profile';
import ShareholdersRegistryPage from 'modules/main/shareholdersRegistry/pages/shareholdersRegistry';
import UsersManagementListPage from 'modules/main/usersManagement/pages/list';
import WalletPage from 'modules/main/wallet/pages/wallet';
import ActionsPage from 'modules/main/actions/actions';
import RegistryTransactionsListPage from 'modules/main/actions/registryTransactions/pages/list';
import HeirsTransactionsListPage from 'modules/main/actions/heirsTransfer/pages/list';
import SuspendListPage from 'modules/main/actions/suspend/pages/list';
import NoticeListPage from 'modules/main/actions/notice/pages/list';
import AnnouncementListPage from 'modules/main/actions/announcement/pages/list';
import UpdateDocumentsListPage from 'modules/main/actions/updateDocuments/pages/list';
import ActionFinancialStatementListPage from 'modules/main/actions/financialStatement/pages/list';
import ShareholderInfoListPage from 'modules/main/actions/shareholderInfo/pages/list';
import ShareholderInfoCreatePage from 'modules/main/actions/shareholderInfo/pages/create';
import RegistryTransactionCreatePage from 'modules/main/actions/registryTransactions/pages/create';
import RegistryTransactionViewPage from 'modules/main/actions/registryTransactions/pages/view';
import CompanyInformationPage from 'modules/main/companyInformation/companyInformation';
import CompanyOverviewPage from 'modules/main/companyInformation/overview/pages/overview';
import TransactionsLogsPage from 'modules/main/companyInformation/transactionsLog/pages/transactionsLogs';
import PaymentsPage from 'modules/main/companyInformation/payments/pages/payments';
import DataRoomPage from 'modules/main/companyInformation/dataRoom/pages/dataRoom';
import CompanyShareholdersListPage from 'modules/main/companyInformation/shareholders/pages/list';
import CompanyInfFinancialStatementPage from 'modules/main/companyInformation/financialStatement/pages/financialStatement';
import UsersManagementCreatePage from 'modules/main/usersManagement/pages/create';
import UsersManagementUpdatePage from 'modules/main/usersManagement/pages/update';
import HeirsTransactionsCreatePage from 'modules/main/actions/heirsTransfer/pages/create';
import HeirsTransactionsViewPage from 'modules/main/actions/heirsTransfer/pages/view';
import SuspendCreatePage from 'modules/main/actions/suspend/pages/create';
import NoticeCreatePage from 'modules/main/actions/notice/pages/create';
import NoticeViewPage from 'modules/main/actions/notice/pages/view';
import UpdateDocumentCreatePage from 'modules/main/actions/updateDocuments/pages/create';
import UpdateDocumentViewPage from 'modules/main/actions/updateDocuments/pages/view';
import ActionFinancialStatementCreatePage from 'modules/main/actions/financialStatement/pages/create';
import ActionFinancialStatementViewPage from 'modules/main/actions/financialStatement/pages/view';
import AnnouncementCreatePage from 'modules/main/actions/announcement/pages/create';
import AnnouncementViewPage from 'modules/main/actions/announcement/pages/view';
import ActionAssembliesListPage from 'modules/main/actions/assemblies/pages/list';
import ActionAssembliesCreatePage from 'modules/main/actions/assemblies/pages/create';
import ActionAssembliesViewPage from 'modules/main/actions/assemblies/pages/view';
import ActionAssembliesEditPage from 'modules/main/actions/assemblies/pages/edit';
import ActionAssembliesAttendanceListPage from 'modules/main/actions/assemblies/pages/attendance';
import ActionAssembliesVotePage from 'modules/main/actions/assemblies/pages/vote';
import CapTableListPage from 'modules/main/companyInformation/capTable/pages/list';
import BrandIdentityPage from 'modules/main/companyInformation/brandIdentity/pages/brandIdentity';
import ShareholderInfoViewPage from 'modules/main/actions/shareholderInfo/pages/view';
import CompanySuspendViewPage from 'modules/main/actions/suspend/pages/companySuspendView';
import SystemSuspendViewPage from 'modules/main/actions/suspend/pages/systemSuspendView';
import PaymentSuccessComponent from 'components/paymentSuccess/paymentSuccess';
import PaymentFailedComponent from 'components/PaymentFailed/PaymentFailed';
import MainBoardPage from 'modules/main/actions/boards/mainBoards';
import BoardsMainListPage from 'modules/main/actions/boards/boards/pages/mainList';
import BoardsListPage from 'modules/main/actions/boards/boards/pages/boardsList';
import BoardMeetingsListPage from 'modules/main/actions/boards/boards/pages/meetingsList';
import BoardCreatePage from 'modules/main/actions/boards/boards/pages/boardCreate';
import BoardAttachMembersPage from 'modules/main/actions/boards/boards/pages/boardAttachMembers';
import MeetingCreatePage from 'modules/main/actions/boards/boards/pages/meetingCreate';
import MeetingViewPage from 'modules/main/actions/boards/boards/pages/meetingView';
import MeetingEditPage from 'modules/main/actions/boards/boards/pages/meetingEdit';
import MeetingDecisionCommentsPage from 'modules/main/actions/boards/boards/pages/meetingDecisionComments';
import BoardDocumentsListPage from 'modules/main/actions/boards/boards/pages/documentsList';
import BoardDocumentCreatePage from 'modules/main/actions/boards/boards/pages/documentCreate';
import BoardDocumentEditPage from 'modules/main/actions/boards/boards/pages/documentEdit';
import CommitteesListPage from 'modules/main/actions/boards/committees/pages/committeesList';
import CommitteeCreatePage from 'modules/main/actions/boards/committees/pages/committeeCreate';
import CommitteeAttachMembersPage from 'modules/main/actions/boards/committees/pages/committeeAttachMembers';
import CommitteeMeetingCreatePage from 'modules/main/actions/boards/committees/pages/meetingCreate';
import CommitteeMeetingViewPage from 'modules/main/actions/boards/committees/pages/meetingView';
import CommitteeMeetingsListPage from 'modules/main/actions/boards/committees/pages/meetingsList';
import MainCapitalPage from 'modules/main/actions/capitals/mainCapitals';
import RaiseCapitalsListPage from 'modules/main/actions/capitals/raise/pages/list';
import RaiseCapitalsCreatePage from 'modules/main/actions/capitals/raise/pages/create';
import RaiseCapitalsViewPage from 'modules/main/actions/capitals/raise/pages/view';
import UpdateAuthorizedCapitalPage from 'modules/main/actions/capitals/raise/pages/authorizedCapital';
import RaiseCapitalsEditPage from 'modules/main/actions/capitals/raise/pages/edit';
import DividendsListPage from 'modules/main/actions/dividends/pages/list';
import DividendCreatePage from 'modules/main/actions/dividends/pages/create';
import DividendViewPage from 'modules/main/actions/dividends/pages/view';
import DividendEditPage from 'modules/main/actions/dividends/pages/edit';
import CommitteesMainListPage from 'modules/main/actions/boards/committees/pages/mainList';
import CommitteeMeetingEditPage from 'modules/main/actions/boards/committees/pages/meetingEdit';
import PaymentCheckComponent from 'components/PaymentCheck/PaymentCheck';
import LoyaltyProgramListPage from 'modules/main/actions/loyalityProgram/pages/list';
import LoyaltyProgramCreatePage from 'modules/main/actions/loyalityProgram/pages/create';
import CommitteeMeetingDecisionCommentsPage from 'modules/main/actions/boards/committees/pages/meetingDecisionComments';
import LoyaltyProgramViewPage from 'modules/main/actions/loyalityProgram/pages/view';
import CommitteeDocumentsListPage from 'modules/main/actions/boards/committees/pages/documentsList';
import CommitteeDocumentCreatePage from 'modules/main/actions/boards/committees/pages/documentCreate';
import CommitteeDocumentEditPage from 'modules/main/actions/boards/committees/pages/documentEdit';
import PublicPage from 'modules/public/public';
import PublicAssemblySummaryPage from 'modules/public/assemblySummary/pages/assemblySummary';

export const MainRoutes: RouteObject[] = [
	{
		path: '',
		element: <App />,
		children: [
			{ path: '', element: <LoginPage /> },
			{ path: 'login', element: <LoginPage /> },
			{ path: 'reset-password', element: <ResetPasswordPage /> },
			{
				path: 'public',
				element: <PublicPage />,
				children: [{ path: 'assembly/:request_number', element: <PublicAssemblySummaryPage /> }],
			},
			{
				path: 'register',
				element: <RegisterPage />,
				children: [
					{ path: '', element: <ContactRegisterForm /> },
					{
						path: 'otp',
						element: (
							<AuthGuard type="register">
								<RegisterOtp />
							</AuthGuard>
						),
					},
					{
						path: 'company',
						element: (
							<AuthGuard type="register">
								<CompanyRegisterForm />
							</AuthGuard>
						),
					},
					{
						path: 'plans',
						element: (
							<AuthGuard type="register">
								<RegistryPlans />
							</AuthGuard>
						),
					},
					{
						path: 'agreement',
						element: (
							<AuthGuard type="register">
								<AgreementRegister />
							</AuthGuard>
						),
					},
				],
			},
			{
				path: '/dashboard',
				element: (
					<AuthGuard>
						<MainDashboardLayout />
					</AuthGuard>
				),
				children: [
					{ path: '', element: <DashboardPage /> },
					{
						path: 'company-documents',
						element: (
							<CheckPermission modules={['companyDocumentView']}>
								<CompanyDocumentsPage />
							</CheckPermission>
						),
					},

					{ path: 'profile', element: <UserProfilePage /> },

					{ path: 'shareholders-registry', element: <ShareholdersRegistryPage /> },

					{
						path: 'company-information',
						element: (
							<CheckPermission modules={['companyOverview']}>
								<CompanyInformationPage />,
							</CheckPermission>
						),
						children: [
							{ path: '', element: <CompanyOverviewPage /> },
							{ path: 'overview', element: <CompanyOverviewPage /> },
							{ path: 'payments', element: <PaymentsPage /> },
							{ path: 'data-room', element: <DataRoomPage /> },
							{ path: 'financial-statement', element: <CompanyInfFinancialStatementPage /> },
							{
								path: 'brand-identity',
								element: (
									<CheckPermission modules={['updateBrandIdentity']}>
										<BrandIdentityPage />,
									</CheckPermission>
								),
							},
						],
					},

					{
						path: 'shareholders-list',
						element: (
							<CheckPermission modules={['companyOverview']}>
								<CompanyShareholdersListPage />
							</CheckPermission>
						),
					},

					{
						path: 'cap-table',
						element: (
							<CheckPermission modules={['companyOverview']}>
								<CapTableListPage />
							</CheckPermission>
						),
					},

					{
						path: 'transactions-logs',
						element: (
							<CheckPermission modules={['companyOverview']}>
								<TransactionsLogsPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions',
						element: <ActionsPage />,
						children: [
							{
								path: 'shareholder-info',
								element: (
									<CheckPermission modules={['shareHolderInformationAction']}>
										<ShareholderInfoListPage />
									</CheckPermission>
								),
							},
							{
								path: 'registry-transactions',
								element: (
									<CheckPermission modules={['registryTransactionAction']}>
										<RegistryTransactionsListPage />
									</CheckPermission>
								),
							},
							{
								path: 'heirs-transfer',
								element: (
									<CheckPermission modules={['heirloomTransactionAction']}>
										<HeirsTransactionsListPage />
									</CheckPermission>
								),
							},
							{
								path: 'suspend',
								element: (
									<CheckPermission modules={['suspendAction']}>
										<SuspendListPage />
									</CheckPermission>
								),
							},
							{
								path: 'notice',
								element: (
									<CheckPermission modules={['noticeAction']}>
										<NoticeListPage />
									</CheckPermission>
								),
							},
							{
								path: 'announcement',
								element: (
									<CheckPermission modules={['announcementAction']}>
										<AnnouncementListPage />
									</CheckPermission>
								),
							},
							{
								path: 'update-documents',
								element: (
									<CheckPermission modules={['updateDocumentAction']}>
										<UpdateDocumentsListPage />
									</CheckPermission>
								),
							},
							{
								path: 'financial-statement',
								element: (
									<CheckPermission modules={['financialStatementAction']}>
										<ActionFinancialStatementListPage />
									</CheckPermission>
								),
							},
							{
								path: 'assemblies',
								element: (
									<CheckPermission modules={['assemblyAction']}>
										<ActionAssembliesListPage />
									</CheckPermission>
								),
							},
							{
								path: 'boards',
								element: (
									<CheckPermission modules={['Board', 'BoardMeeting']}>
										<MainBoardPage />
									</CheckPermission>
								),
								children: [
									{
										path: '',
										element: <BoardsMainListPage />,
										children: [
											{ path: '', element: <BoardsListPage /> },
											{ path: 'meetings', element: <BoardMeetingsListPage /> },
											{ path: 'documents', element: <BoardDocumentsListPage /> },
											{
												path: 'create',
												element: (
													<CheckSuspended redirectTo="/dashboard/actions/boards">
														<BoardCreatePage />
													</CheckSuspended>
												),
											},
											{ path: ':id/attach-members', element: <BoardAttachMembersPage /> },
										],
									},
									{
										path: 'committees',
										element: <CommitteesMainListPage />,
										children: [
											{ path: '', element: <CommitteesListPage /> },
											{ path: 'meetings', element: <CommitteeMeetingsListPage /> },
											{ path: 'documents', element: <CommitteeDocumentsListPage /> },
											{
												path: 'create',
												element: (
													<CheckSuspended redirectTo="/dashboard/actions/boards/committees">
														<CommitteeCreatePage />
													</CheckSuspended>
												),
											},
											{ path: ':id/attach-members', element: <CommitteeAttachMembersPage /> },
											
										],
									},
								],
							},
							{
								path: 'capitals',
								element: (
									<CheckPermission modules={['raiseCapital', 'updateAuthorizedCapital']}>
										<MainCapitalPage />
									</CheckPermission>
								),
								children: [{ path: '', element: <RaiseCapitalsListPage /> }],
							},
							{
								path: 'dividends',
								element: (
									<CheckPermission modules={['dividends']}>
										<DividendsListPage />
									</CheckPermission>
								),
								children: [{ path: '', element: <RaiseCapitalsListPage /> }],
							},
							{
								path: 'loyalty-programs',
								element: (
									// <CheckPermission modules={['dividends']}>
									<LoyaltyProgramListPage />
									// </CheckPermission>
								),
							},
						],
					},

					{
						path: 'actions/shareholder-info/create',
						element: (
							<CheckPermission modules={['shareHolderInformationAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/shareholder-info">
									<ShareholderInfoCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/shareholder-info/:national_id',
						element: (
							<CheckPermission modules={['shareHolderInformationAction']}>
								<ShareholderInfoViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/registry-transactions/create',
						element: (
							<CheckPermission modules={['registryTransactionAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/registry-transactions">
									<RegistryTransactionCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/registry-transactions/:id',
						element: (
							<CheckPermission modules={['registryTransactionAction']}>
								<RegistryTransactionViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/heirs-transfer/create',
						element: (
							<CheckPermission modules={['heirloomTransactionAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/heirs-transfer">
									<HeirsTransactionsCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/heirs-transfer/:id',
						element: (
							<CheckPermission modules={['heirloomTransactionAction']}>
								<HeirsTransactionsViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/suspend/create',
						element: (
							<CheckPermission modules={['suspendAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/suspend">
									<SuspendCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/suspend/company/:id',
						element: (
							<CheckPermission modules={['suspendAction']}>
								<CompanySuspendViewPage />
							</CheckPermission>
						),
					},
					{
						path: 'actions/suspend/system/:id',
						element: (
							<CheckPermission modules={['suspendAction']}>
								<SystemSuspendViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/notice/create',
						element: (
							<CheckPermission modules={['noticeAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/notice">
									<NoticeCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/notice/:id',
						element: (
							<CheckPermission modules={['noticeAction']}>
								<NoticeViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/update-documents/create',
						element: (
							<CheckPermission modules={['updateDocumentAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/update-documents">
									<UpdateDocumentCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/update-documents/:id',
						element: (
							<CheckPermission modules={['updateDocumentAction']}>
								<UpdateDocumentViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/financial-statement/create',
						element: (
							<CheckPermission modules={['financialStatementAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/financial-statement">
									<ActionFinancialStatementCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/financial-statement/:id',
						element: (
							<CheckPermission modules={['financialStatementAction']}>
								<ActionFinancialStatementViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/announcement/create',
						element: (
							<CheckPermission modules={['announcementAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/announcement">
									<AnnouncementCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/announcement/:id',
						element: (
							<CheckPermission modules={['announcementAction']}>
								<AnnouncementViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/assemblies/create',
						element: (
							<CheckPermission modules={['assemblyAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/assemblies">
									<ActionAssembliesCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/assemblies/view/:id',
						element: (
							<CheckPermission modules={['assemblyAction']}>
								<ActionAssembliesViewPage />
							</CheckPermission>
						),
					},
					{
						path: 'actions/assemblies/:id',
						element: (
							<CheckPermission modules={['assemblyAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/assemblies">
									<ActionAssembliesEditPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/assemblies/:id/attendance',
						element: (
							<CheckPermission modules={['assemblyAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/assemblies">
									<ActionAssembliesAttendanceListPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/assemblies/:assemblyId/attendance/vote/:shareholderId',
						element: (
							<CheckPermission modules={['assemblyAction']}>
								<CheckSuspended redirectTo="/dashboard/actions/assemblies">
									<ActionAssembliesVotePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},

					{
						path: 'actions/boards/meetings/create',
						element: (
							<CheckPermission modules={['BoardMeeting']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/meetings">
									<MeetingCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/boards/meetings/view/:id',
						element: (
							<CheckPermission modules={['BoardMeeting']}>
								<MeetingViewPage />
							</CheckPermission>
						),
					},
					{
						path: 'actions/boards/meetings/:id',
						element: (
							<CheckPermission modules={['BoardMeeting']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/meetings">
									<MeetingEditPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					// {
					// 	path: 'actions/boards/meetings/:id/attendance',
					// 	element: (
					// 		<CheckPermission modules={['BoardMeeting']}>
					// 			<ActionBoardsAttendanceListPage />
					// 		</CheckPermission>
					// 	),
					// },
					{
						path: 'actions/boards/meetings/:id/decision-comments',
						element: (
							<CheckPermission modules={['BoardMeeting']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/meetings">
									<MeetingDecisionCommentsPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					// {
					// 	path: 'actions/boards/meetings/:meetingId/attendance/vote/:shareholderId',
					// 	element: (
					// 		<CheckPermission modules={['BoardMeeting']}>
					// 			<ActionBoardsVotePage />
					// 		</CheckPermission>
					// 	),
					// },
					{
						path: 'actions/boards/documents/create',
						element: (
							<CheckPermission modules={['Board']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/documents">
									<BoardDocumentCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/boards/documents/:id',
						element: (
							<CheckPermission modules={['Board']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/documents">
									<BoardDocumentEditPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},

					{
						path: 'actions/boards/committees/:id/meetings/create',
						element: (
							<CheckPermission modules={['BoardMeeting']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/committees/meetings">
									<CommitteeMeetingCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/boards/committees/:committeeId/meetings/view/:meetingId',
						element: (
							<CheckPermission modules={['BoardMeeting']}>
								<CommitteeMeetingViewPage />
							</CheckPermission>
						),
					},
					{
						path: 'actions/boards/committees/:committeeId/meetings/:meetingId',
						element: (
							<CheckPermission modules={['BoardMeeting']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/committees/meetings">
									<CommitteeMeetingEditPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/boards/committees/:committeeId/meetings/:meetingId/decision-comments',
						element: (
							<CheckPermission modules={['BoardMeeting']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/committees/meetings">
									<CommitteeMeetingDecisionCommentsPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/boards/committees/:committeeId/documents/create',
						element: (
							<CheckPermission modules={['Board']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/committees/documents">
									<CommitteeDocumentCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/boards/committees/:committeeId/documents/:documentId',
						element: (
							<CheckPermission modules={['Board']}>
								<CheckSuspended redirectTo="/dashboard/actions/boards/committees/documents">
									<CommitteeDocumentEditPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},


					{
						path: 'actions/capitals/create',
						element: (
							<CheckPermission modules={['raiseCapital']}>
								<CheckSuspended redirectTo="/dashboard/actions/capitals">
									<RaiseCapitalsCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/capitals/authorized-capital',
						element: (
							<CheckPermission modules={['updateAuthorizedCapital']}>
								<CheckSuspended redirectTo="/dashboard/actions/capitals">
									<UpdateAuthorizedCapitalPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/capitals/:id',
						element: (
							<CheckPermission modules={['raiseCapital']}>
								<CheckSuspended redirectTo="/dashboard/actions/capitals">
									<RaiseCapitalsEditPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/capitals/view/:id',
						element: (
							<CheckPermission modules={['raiseCapital']}>
								<RaiseCapitalsViewPage />
							</CheckPermission>
						),
					},

					{
						path: 'actions/dividends/create',
						element: (
							<CheckPermission modules={['dividends']}>
								<CheckSuspended redirectTo="/dashboard/actions/dividends">
									<DividendCreatePage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/dividends/:id',
						element: (
							<CheckPermission modules={['dividends']}>
								<CheckSuspended redirectTo="/dashboard/actions/dividends">
									<DividendEditPage />
								</CheckSuspended>
							</CheckPermission>
						),
					},
					{
						path: 'actions/dividends/view/:id',
						element: (
							<CheckPermission modules={['dividends']}>
								<DividendViewPage />
							</CheckPermission>
						),
					},
					{
						path: 'actions/loyalty-programs/create',
						element: (
							// <CheckPermission modules={['dividends']}>
								<CheckSuspended redirectTo="/dashboard/actions/loyalty-programs">
									<LoyaltyProgramCreatePage />
								</CheckSuspended>
							// </CheckPermission>
						),
					},
					{
						path: 'actions/loyalty-programs/view/:id',
						element: (
							// <CheckPermission modules={['dividends']}>
								<LoyaltyProgramViewPage />
							// </CheckPermission>
						),
					},

					{
						path: 'users-management',
						element: (
							<CheckPermission modules={['companyUserManagement']}>
								<UsersManagementListPage />
							</CheckPermission>
						),
					},
					{
						path: 'users-management/create',
						element: (
							<CheckPermission modules={['companyUserManagement']}>
								<UsersManagementCreatePage />
							</CheckPermission>
						),
					},
					{
						path: 'users-management/:id',
						element: (
							<CheckPermission modules={['companyUserManagement']}>
								<UsersManagementUpdatePage />
							</CheckPermission>
						),
					},

					{
						path: 'wallet',
						element: (
							<CheckPermission modules={['chargePoints']}>
								<WalletPage />
							</CheckPermission>
						),
					},
				],
			},
			{ path: 'payment-check', element: <PaymentCheckComponent /> },
			{ path: '*', element: <NotFoundPage /> },
		],
	},
];
